import { render, staticRenderFns } from "./NewsRegulator.vue?vue&type=template&id=a6e69fd4&"
import script from "./NewsRegulator.vue?vue&type=script&lang=js&"
export * from "./NewsRegulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports